module.exports = __webpack_public_path__ + "c_static/img/mine_Entrance_invite-friends_default@2x.985839e.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img/邀请好友/mine_Entrance_invite-friends_default@2x.png
// module id = UP0C
// module chunks = 33